// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 761 ? "d0deef33" : chunkId) + "." + {"69":"9a2f779a3c89b1d7","761":"35be909627f4a081"}[chunkId] + ".js";
};